<script>
import Styled from '@components/utility/Styled.vue'

export default {
  name: 'BulkCreationTableBaseStyle',
  components: {
    Styled
  }
}
</script>

<template>
  <Styled className="bulk-creation-table-base">
    <slot></slot>
  </Styled>
</template>

<style scoped lang="scss">
.bulk-creation-table-base {
  width: 100%;
  background-color: $bgColorBase;
  border-radius: 5px;

  ::v-deep td, ::v-deep th {
    padding-left: 5px;
    padding-right: 5px;
    height: 34px;

    &:first-child {
      width: 0;
      padding-left: 20px;
    }

    &:last-child {
      width: 0;
      padding-right: 20px;
    }
  }

  ::v-deep th {
    height: 40px;
    padding-top: 10px;
    padding-bottom: 5px;
    font-weight: normal;
    font-size: 11px;
    text-transform: uppercase;
    color: $fontColor2;
  }

  ::v-deep tr {
    &:last-child td {
      padding-bottom: 10px;
    }
  }

  ::v-deep .status-column {
    & > span {
      vertical-align: middle;
    }
  }

  ::v-deep .actions-column {
    text-align: left;
    padding-left: 18px;
  }
}
</style>
